import { ApiService } from '../apiService'
import type {
  ReportPage,
  ReportSort,
  ReportView,
  ReportedMediaFile,
  UnusedMediaReportStatus,
  UntrackedObject,
} from '../types/storageReport'

/**
 * The unused media report. Every call here is read-only: running a report reads every media
 * record and lists the bucket, and nothing in this API deletes anything.
 */
export const storageReportApi = {
  status: () => ApiService.get<UnusedMediaReportStatus>('/admin/media/unused-report'),

  run: () => ApiService.post<UnusedMediaReportStatus>('/admin/media/unused-report/run'),

  files: (params: { view: ReportView; search?: string; sort: ReportSort; page: number; pageSize: number }) =>
    ApiService.get<ReportPage<ReportedMediaFile>>('/admin/media/unused-report/files', params),

  untracked: (params: { prefix?: string; search?: string; page: number; pageSize: number }) =>
    ApiService.get<ReportPage<UntrackedObject>>('/admin/media/unused-report/untracked', params),
}
